import { createSvgIcon } from '@mui/material'

export const PdfDocumentIcon = createSvgIcon(
  <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect opacity='0.16' width='40' height='40' rx='8' fill='#DFE3E8' />
    <rect width='24' height='24' transform='translate(8 8)' fill='#F4F6F8' />
    <path
      d='M13.9238 9H24.0738C26.6272 10.8084 28.8536 13.039 30.6573 15.5957V31.2075H13.9238V9Z'
      fill='url(#paint0_linear_8324_83313)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.9238 9H24.0738C26.6272 10.8084 28.8536 13.039 30.6573 15.5957V31.2075H13.9238V9Z'
      stroke='#C8C8C8'
      strokeWidth='0.5'
    />
    <path
      d='M24.0718 9C26.622 10.8128 28.8483 13.0426 30.657 15.5957C29.4398 14.3448 27.7325 13.6948 25.9915 13.8195C26.241 11.9875 25.5125 10.1587 24.0718 9L24.0718 9Z'
      fill='url(#paint1_linear_8324_83313)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M24.0718 9C26.622 10.8128 28.8483 13.0426 30.657 15.5957C29.4398 14.3448 27.7325 13.6948 25.9915 13.8195C26.241 11.9875 25.5125 10.1587 24.0718 9L24.0718 9Z'
      stroke='#C8C8C8'
      strokeWidth='0.5'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.6641 11.9172H23.0016V14.2797H10.6641V11.9172Z'
      stroke='#C8C8C8'
      strokeWidth='3.5'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.9255 23.428C19.8949 23.488 19.8645 23.5475 19.8344 23.6065L19.8318 23.6039C18.1483 26.8983 16.8402 28.6763 15.9652 28.8005V28.7647C15.9468 28.3534 16.7054 27.2938 17.7335 26.4512C17.8403 26.3645 18.2979 25.9218 18.2979 25.9218C18.2979 25.9218 17.6802 26.2447 17.5419 26.3322C16.2539 27.1013 15.6125 27.8722 15.5084 28.3832C15.4596 28.5336 15.5086 28.6986 15.6318 28.7979L15.9617 28.9633C16.8577 29.4122 17.9602 28.2327 19.4258 25.6637C21.0729 25.128 22.7608 24.7268 24.4728 24.464C25.9892 25.3303 27.7287 25.7398 28.3972 25.5648C28.5276 25.5249 28.6427 25.4462 28.727 25.339C28.7826 25.2021 28.8254 25.0603 28.8548 24.9155C28.7924 25.0029 28.7147 25.0782 28.6255 25.1378C28.2029 25.3373 26.8668 25.0039 25.4965 24.3337C26.3919 24.189 27.3057 24.2018 28.1968 24.3713C28.8662 24.5865 28.8662 24.8044 28.8574 24.849C28.8775 24.7682 28.8895 24.6855 28.8933 24.6023C28.8856 24.4429 28.8192 24.2921 28.7069 24.1788C28.1972 23.8731 27.6025 23.7403 27.0112 23.7999C26.2739 23.8001 25.5378 23.8553 24.8088 23.9653C24.4203 23.7583 24.0563 23.5082 23.7238 23.2198C22.8772 22.4028 22.2343 21.3985 21.8469 20.2877C21.8758 20.1774 21.9029 20.0689 21.9274 19.9595C22.0429 19.4424 22.1252 17.7309 22.1252 17.7309C22.1252 17.7309 21.7979 19.0163 21.7463 19.2105C21.7113 19.3339 21.671 19.4652 21.6238 19.6017C21.393 18.8258 21.2656 18.0229 21.2449 17.2138C21.2453 16.9385 21.2679 16.6638 21.3123 16.3922C21.3155 16.2535 21.3795 16.1233 21.4873 16.036C21.6369 16.0737 21.804 16.302 21.979 16.6862C22.0927 16.9909 22.1407 17.3162 22.1199 17.6408C22.205 17.3355 22.2465 17.0197 22.2433 16.7028C22.2205 16.4937 22.0219 15.9555 21.5984 15.9617H21.3762C21.0902 15.936 20.8203 16.0979 20.7085 16.3624C20.4487 17.3197 20.7392 18.8002 21.2239 20.6447L21.0769 21.0017C20.7365 21.8397 20.3105 22.6739 19.9255 23.428ZM19.5553 25.3487C19.8314 24.8614 20.1015 24.3708 20.3655 23.8769H20.3612C20.8039 23.0469 21.189 22.1874 21.5135 21.3044C21.9574 22.217 22.5826 23.0295 23.351 23.6923C23.5299 23.8426 23.7159 23.9843 23.9084 24.1167C22.4181 24.3732 20.959 24.7861 19.5553 25.3487Z'
      fill='#F91D0A'
    />
    <path
      d='M9.27393 10.5803H24.3799V15.6579H9.27393V10.5803Z'
      fill='url(#paint2_linear_8324_83313)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 15.9625H24.6678V10.2759H9V15.9625ZM9.5635 10.8394H24.1051V15.3973H9.5635V10.8394Z'
      fill='url(#paint3_linear_8324_83313)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.2217 11.3247H14.3207C14.6015 11.3067 14.8761 11.4126 15.0723 11.6143C15.2608 11.8444 15.3546 12.1375 15.3348 12.4342C15.3546 12.7323 15.2608 13.0268 15.0723 13.2585C14.8757 13.4593 14.6011 13.5641 14.3207 13.5455H13.8832V14.7258H13.2217V11.3247ZM13.8841 11.9635V12.9102H14.2507C14.3635 12.9167 14.473 12.8712 14.5482 12.7868C14.6232 12.6861 14.6604 12.5622 14.6532 12.4368C14.6612 12.3114 14.624 12.1872 14.5482 12.0868C14.4731 12.0024 14.3635 11.9569 14.2507 11.9635H13.8841ZM16.4644 14.0635V11.9941H16.7016C16.9385 11.9784 17.1689 12.0758 17.3228 12.2566C17.4796 12.4814 17.5549 12.7531 17.5363 13.0266C17.5549 13.3017 17.479 13.5749 17.3211 13.801C17.1679 13.9819 16.938 14.0793 16.7016 14.0635H16.4644ZM15.8021 11.3308H16.5021C16.7945 11.3159 17.0872 11.3518 17.3674 11.4367C17.5631 11.5128 17.7334 11.6423 17.8592 11.8103C17.982 11.9685 18.0733 12.1488 18.1278 12.3415C18.189 12.5634 18.2185 12.7929 18.2153 13.0231C18.2185 13.2553 18.1891 13.4868 18.1278 13.7108C18.0733 13.9035 17.982 14.0839 17.8592 14.242C17.7318 14.4105 17.5605 14.5407 17.3639 14.6182C17.0832 14.7035 16.79 14.7404 16.4968 14.7276H15.7968V11.3247L15.8021 11.3308ZM20.5174 11.3247H18.7263V14.7258H19.3887V13.2838H20.4466V12.6206H19.3887V11.988H20.5174V11.3247Z'
      fill='#FFF9F9'
    />
    <defs>
      <linearGradient
        id='paint0_linear_8324_83313'
        x1='23.0235'
        y1='30.5037'
        x2='31.6302'
        y2='21.6719'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#E1E1E1' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_8324_83313'
        x1='27.043'
        y1='13.4746'
        x2='27.9964'
        y2='12.5985'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#C8C8C8' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_8324_83313'
        x1='31.7304'
        y1='17.1422'
        x2='31.3953'
        y2='8.01416'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.127' stopColor='#8A0000' />
        <stop offset='0.244' stopColor='#900000' stopOpacity='0.999' />
        <stop offset='0.398' stopColor='#A00000' stopOpacity='0.999' />
        <stop offset='0.573' stopColor='#BC0000' stopOpacity='0.998' />
        <stop offset='0.761' stopColor='#E20000' stopOpacity='0.997' />
        <stop offset='0.867' stopColor='#FA0000' stopOpacity='0.996' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_8324_83313'
        x1='31.847'
        y1='17.4187'
        x2='31.4248'
        y2='7.5529'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0.315' stopColor='#5E0000' />
        <stop offset='0.444' stopColor='#830000' stopOpacity='0.999' />
        <stop offset='0.618' stopColor='#AE0000' stopOpacity='0.998' />
        <stop offset='0.775' stopColor='#CD0000' stopOpacity='0.997' />
        <stop offset='0.908' stopColor='#E00000' stopOpacity='0.996' />
        <stop offset='1' stopColor='#E70000' stopOpacity='0.996' />
      </linearGradient>
    </defs>
  </svg>,
  'PdfDocumentIcon',
)
